import {Component, Input} from '@angular/core';
import {UntypedFormControl} from "@angular/forms";

@Component({
    selector: 'app-unified-review-row',
    templateUrl: './unified-review-row.component.html',
    styleUrls: ['./unified-review-row.component.scss'],
    standalone: false
})
export class UnifiedReviewRowComponent {

  @Input() label: string;
  @Input() value: string;
  @Input() placeholder = "";
  @Input() control: UntypedFormControl;
  @Input() customErrorMessage: string;
  @Input() editable: boolean = true;

}
